export default __webpack_public_path__ + "static/media/granville17.df747270.jpg";